/* eslint-disable */
import { useState, useEffect, memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import moment from 'moment';
import './commonCalendar.scss';

// Custom event tooltip component for the calendar
const CustomEvent = memo(({ event }) => {
  const [isMobileView, setIsMobileView] = useState(false);

  // Memoize events data to prevent unnecessary recalculations
  const eventsData = useMemo(() => {
    const eventsForDay = event.groupedSessions || [event];
    const firstEvent = eventsForDay[0];
    const moreCount = eventsForDay.length - 1;
    
    return { eventsForDay, firstEvent, moreCount };
  }, [event.groupedSessions, event]);

  const checkMobileView = useCallback(() => {
    setIsMobileView(window.innerWidth < 576);
  }, []);

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, [checkMobileView]);

  // Memoized tooltip content to prevent recreating on every render
  const tooltipContent = useMemo(() => (
    <div className="calendar-event-tooltip">
      {eventsData.eventsForDay.map((events) => (
        <div key={events.id} className="calendar-event-tooltip-item">
          <div className="calendar-event-item-title">{events.title}</div>
          <div>
            {moment(events.start).format('hh:mm A')} -{' '}
            {moment(events.end).format('hh:mm A')}
          </div>
          <div>
            {events.sessionType}
            {events.location && events.location !== '-' && ` - ${events.location}`}
          </div>
        </div>
      ))}
    </div>
  ), [eventsData.eventsForDay]);

  // Memoized formatted time to avoid recalculation
  const formattedStartTime = useMemo(() => 
    moment(eventsData.firstEvent.start).format(
      moment(eventsData.firstEvent.start).minutes() === 0 ? 'h A' : 'h:mm A'
    ), [eventsData.firstEvent.start]
  );

  return (
    <Tooltip
      title={tooltipContent}
      classes={{ tooltip: 'common-calendar-tooltip' }}
    >
      <Tooltip>
        <div className="calendar-event-summary">
          <div className="calendar-event-title">
            {formattedStartTime} - {eventsData.firstEvent.title}
          </div>

          {!isMobileView && eventsData.moreCount > 0 && (
            <div className={'calendar-event-tooltip-count'}>
              <div className="more-count">+{eventsData.moreCount}</div>
            </div>
          )}
        </div>
      </Tooltip>
    </Tooltip>
  );
});

CustomEvent.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number.isRequired,
    start: PropTypes.instanceOf(Date).isRequired,
    title: PropTypes.string.isRequired,
    groupedSessions: PropTypes.array,
  }).isRequired,
};

export default memo(CustomEvent);